export const updateDashboardActionItems = (activities, payload) => {
    const { activityId, updatedActionList } = payload;
    const updatedActivityIndex = activities.findIndex(activity => activity.id === activityId);

    if (updatedActivityIndex !== -1) {
        activities[updatedActivityIndex]['todos'] = updatedActionList;
    }

    return [...activities];
}